export function setLocalStorageItem(key, value) {
    if (value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    else {
        localStorage.removeItem(key);
    }
}
export function getLocalStorageItem(key) {
    const item = localStorage.getItem(key);
    return !!item ? JSON.parse(item) : undefined;
}
export const removeLocalStorageItem = (key) => {
    localStorage.removeItem(key);
};
//# sourceMappingURL=LocalStorageUtil.js.map